<a class="dropdown-item" id="ExportPlantsToExcelButton" (click)="exportToExcel()"
href="javascript:;">
<i class="fa fa-download mr-2 mt-1" style="font-size: 1rem;"></i>
{{'ExportProjectActivitiesToExcel' | localize}}
</a>